
import React from 'react';
import { Helmet } from 'react-helmet';

interface WebsiteStructuredDataProps {
  baseUrl: string;
  siteName?: string;
  description?: string;
  logoUrl?: string;
  socialProfiles?: string[];
}

export function WebsiteStructuredData({ 
  baseUrl, 
  siteName = 'Trotting the World',
  description = 'Expert travel guides, itineraries, and tips for adventure seekers and global explorers.',
  logoUrl = '/logo.png',
  socialProfiles = []
}: WebsiteStructuredDataProps) {
  
  // Create the structured data for the website organization
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": siteName,
    "url": baseUrl,
    "logo": {
      "@type": "ImageObject",
      "url": logoUrl.startsWith('http') ? logoUrl : `${baseUrl}${logoUrl}`,
      "width": 600,
      "height": 60
    },
    "description": description,
    ...(socialProfiles.length > 0 ? { "sameAs": socialProfiles } : {}),
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "url": `${baseUrl}/contact`
    }
  };
  
  // Create a WebSite structured data
  const websiteStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": siteName,
    "url": baseUrl,
    "description": description,
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/search?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteStructuredData)}
      </script>
    </Helmet>
  );
}
